import React, { useState } from "react";
import axios from "axios";
import "./login.css";
import google from "../../../assets/google.png";
import linkedin from "../../../assets/linkedin.png";
import fbook from "../../../assets/facebook.png";

const LoginForm = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(
        "http://localhost:5000/api/v1/user/login",
        { username: email, password },
        { headers: { "Content-type": "application/json" } }
      );
      if (onClose) onClose();
    } catch (error) {
      alert("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginForm">
      <p className="formTitle">Sign in to access your personalized job matches and saved applications.</p>

      <div className="socialRow">
        <button className="socialBtn" type="button">
          <img src={google} alt="Google" className="socialIcon" />
          Google
        </button>
        <button className="socialBtn" type="button">
          <img src={linkedin} alt="LinkedIn" className="socialIcon" />
          LinkedIn
        </button>
        <button className="socialBtn" type="button">
          <img src={fbook} alt="Facebook" className="socialIcon" />
          Facebook
        </button>
      </div>

      <div className="divider">
        <span className="dividerText">or continue with email</span>
      </div>

      <form onSubmit={handleLogin}>
        <div className="inputGroup">
          <label className="inputLabel">Email or Username</label>
          <input
            type="text"
            className="inputField"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="inputGroup">
          <label className="inputLabel">Password</label>
          <input
            type="password"
            className="inputField"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div className="forgotRow">
          <a href="#" className="forgotLink">Forgot password?</a>
        </div>

        <button type="submit" className="submitBtn" disabled={loading}>
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>

      <p className="switchRow">
        Don't have an account?{" "}
        <span className="switchLink" onClick={onClose}>Sign up for free</span>
      </p>
    </div>
  );
};

export default LoginForm;
